import { $api } from "./request.config";

import store from "../store/store";
import { fetchClaimsThunk } from "../actions/User/User Claims/thunk/fetchClaimsThunk";

import axios from "axios";



let isRefreshing = false;
let failedQueue = [];


const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};


$api.interceptors.request.use((config) => {

    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;

    return config;

}, (error) => {

    // console.log("interceptor error:", error)

    return Promise.reject(error);

});


$api.interceptors.response.use(
    response => {
        return response;
    },
    err => {
        const originalRequest = err.config;

        if (!err.response) {
            return Promise.reject(err);
        }

        if (err.response.status === 401 && !originalRequest._retry) {

            // const idleTimeout = setTimeout(() => {
            //     window.location.assign('/start')
            //     localStorage.clear()
            // }, 1000)
            if (isRefreshing) {

                // idleTimeout()

                return new Promise(function(resolve, reject) {
                    if (err.response?.request?.responseURL?.includes("v1/auth/refresh")) {
                        const idleTimeout = setTimeout(() => {
                            localStorage.clear();
                            window.location.assign("/start");
                        }, 1000);

                    } else {
                        failedQueue.push({ resolve, reject });
                    }
                })
                    .then(token => {

                        originalRequest.headers["Authorization"] = "Bearer " + token;
                        return axios(originalRequest);
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            return new Promise(function(resolve, reject) {
                const id = localStorage.getItem("userId");
                const authToken = localStorage.getItem("token");
                const refreshToken = localStorage.getItem("refreshToken");
                // const signType = $api
                //     .get("v1/sections-access/general")
                //     .catch((error) => localStorage.setItem(
                //         "restricted",
                //         "false",
                //     ));
                // console.log(signType);
                $api
                    .post("v1/auth/refresh", {
                        refreshToken, id, authToken, consumer: 1,
                    })
                    .then(({ data }) => {
                        axios.defaults.headers.common["Authorization"] = "Bearer " + data.token;
                        originalRequest.headers["Authorization"] = "Bearer " + data.token;
                        processQueue(null, data.token);
                        localStorage.setItem("refreshToken", data.refreshToken);
                        localStorage.setItem("token", data.token);
                        // store.dispatch(fetchClaimsThunk());
                        resolve(axios(originalRequest));
                        // clearTimeout(idleTimeout)
                    })
                    .catch(err => {
                        processQueue(err, null);
                        reject(err);
                        // const idleTimeout = setTimeout(() => {
                        //     window.location.assign("/star");
                        //     localStorage.clear();
                        // }, 1000);
                    })
                    .then(() => {
                        isRefreshing = false;
                    });


            });
        }
        return Promise.reject(err);
    },
);

export default $api;
